import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Menubar from "@radix-ui/react-menubar";
import ListView from "./ListView";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import FilterListings from "./filters/FilterListings";
import { PaginationComponent } from "./ui/Pagination";
import { useSearchParams } from "react-router-dom";

interface IProps {}

export const SideBar = (props: IProps) => {
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();

  const [windowSize, setWindowSize] = React.useState(getWindowSize());
  const [sidebarHeight, setSidebarHeight] = React.useState(100);
  const [currentListing, setCurrentListing] = React.useState<any>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [filteredListings, setFilteredListings] = React.useState<any>([]);
  const [currentPage, setCurrentPage] = React.useState<number>(() => {
    const storedPage = localStorage.getItem("currentPage");
    return storedPage ? parseInt(storedPage, 10) : 0;
  });
  const searchSection = React.useRef<HTMLDivElement>(null);

  const itemsPerPage = 10;

  const logged = useSelector((state: any) => state.listingReducer.logged);
  const favoritesShow = useSelector(
    (state: any) => state.listingReducer.favoritesShow
  );
  const remindersShow = useSelector(
    (state: any) => state.listingReducer.remindersShow
  );
  const routesShow = useSelector(
    (state: any) => state.listingReducer.routesShow
  );
  const teamActivityShow = useSelector(
    (state: any) => state.listingReducer.teamActivityShow
  );

  React.useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  React.useEffect(() => {
    if (windowSize.innerWidth > 768) {
      setSidebarHeight(windowSize.innerHeight);
    } else {
      setSidebarHeight(windowSize.innerHeight / 2);
    }
  }, [windowSize]);

  function getWindowSize() {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  }

  const filterValues = useSelector(
    (state: any) => state.listingReducer.filterValues
  );
  const listings = useSelector((state: any) => state.listingReducer.listings);
  const userFavorites = useSelector(
    (state: any) => state.listingReducer.userFavorites
  );

  const prevFilterValuesRef = React.useRef(filterValues);

  React.useEffect(() => {
    if (
      JSON.stringify(filterValues) !==
      JSON.stringify(prevFilterValuesRef.current)
    ) {
      setCurrentPage(0);
      localStorage.setItem("currentPage", "0");
    }
    prevFilterValuesRef.current = filterValues;
  }, [filterValues]);

  React.useEffect(() => {
    setLoading(true);
    setFilteredListings(filterListing());
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, [filterValues, listings, currentPage]);

  React.useEffect(() => {
    const isSticky = () => {
      const scrollTop = window.scrollY;
      if (!searchSection.current) return;
      scrollTop >= 320
        ? searchSection.current?.classList?.add("fixed", "top-[4.5rem]", "z-20")
        : searchSection.current?.classList?.remove("fixed", "top-0");
    };

    window.addEventListener("scroll", isSticky);

    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  React.useEffect(() => {
    localStorage.setItem("currentPage", currentPage.toString());
  }, [currentPage]);

  function onPageChange(page: number) {
    setCurrentPage(page);
  }

  function filterListing() {
    let returnListings = listings;
    /*if (filterValues.filterState && filterValues.filterState !== '') {
                returnListings = listings.filter((item: any) => item.state === filterValues.filterState);
            }*/
    if (filterValues.filterTime && filterValues.filterTime !== "") {
      let timeCheck =
        Math.floor(Date.now() / 1000) - filterValues.filterTime * 24 * 60 * 60;
      returnListings = returnListings.filter(
        (item: any) => item.time_listed >= timeCheck
      );
    }
    /*if (filterValues.filterLeadOwner && filterValues.filterLeadOwner !== '') {
                returnListings = returnListings.filter((item: any) => item.lead_owner?.toLowerCase() === filterValues.filterLeadOwner.toLowerCase());
            }*/
    if (filterValues.filterLeadStatus && filterValues.filterLeadStatus !== "") {
      returnListings = returnListings.filter(
        (item: any) =>
          item.lead_status_options_public_id === filterValues.filterLeadStatus
      );
    }
    if (
      filterValues.filterBySourceType &&
      filterValues.filterBySourceType !== ""
    ) {
      returnListings = returnListings.filter(
        (item: any) => item.source_type === filterValues.filterBySourceType
      );
    }
    if (filterValues.filterBounds && filterValues.filterBounds !== "") {
      returnListings = returnListings.filter(
        (item: { latitude: string; longitude: string }) => {
          const lat = parseFloat(item.latitude);
          const lng = parseFloat(item.longitude);
          return filterValues.filterBounds.contains(
            new window.google.maps.LatLng(lat, lng)
          );
        }
      );
      //console.log('owner-', returnListings)
    }

    if (filterValues.filterEquity) {
      returnListings = returnListings.filter(
        (itm: any) =>
          Number(itm.equity_percent) >= filterValues.filterEquity.start &&
          Number(itm.equity_percent) <= filterValues.filterEquity.end
      );
    }

    if (filterValues.filterBuiltYear) {
      returnListings = returnListings.filter(
        (itm: any) =>
          Number(itm.year_built) >= filterValues.filterBuiltYear.start &&
          Number(itm.year_built) <= filterValues.filterBuiltYear.end
      );
    }

    if (filterValues.filterBathrooms) {
      returnListings = returnListings.filter(
        (itm: any) => Number(itm.bathrooms) >= filterValues.filterBathrooms
      );
    }

    if (filterValues.filterBedrooms) {
      returnListings = returnListings.filter(
        (itm: any) => Number(itm.bedrooms) >= filterValues.filterBedrooms
      );
    }

    if (filterValues.filterByPriceDrop?.length > 0) {
      returnListings = returnListings.filter((itm: any) =>
        filterValues.filterByPriceDrop.includes(itm.price_drop)
      );
    }
    return returnListings;
  }

  const totalPages = Math.ceil(filteredListings.length / itemsPerPage);
  const startIndex = currentPage === 0 ? 0 : currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentListings = filteredListings.slice(startIndex, endIndex);

  return (
    <div className="h-full">
      <div className="bg-white w-full p-3 mt-4" ref={searchSection}>
        <div className="text-gray-600 text-sm font-semibold flex items-center justify-between mt-3">
          <p>{filteredListings.length} Results</p>
        </div>
      </div>
      <div className="mt-0 p-3">
        {/* <ListItem /> */}
        {currentListings.length > 0 ? (
          <ListView currentListings={currentListings} />
        ) : (
          <div className="text-center mt-3">
            <h2 className="text-2xl text-black font-semibold">
              No matching results
            </h2>
            <p>Try changing your search</p>
          </div>
        )}

        {currentListings.length ? (
          <PaginationComponent
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={onPageChange}
          />
        ) : null}
      </div>
    </div>
  );
};
export default SideBar;
